import { Injectable } from '@angular/core';

import { DropDownModel } from '../../models/dropDownModel';
import { UpdateXrefsModel } from '../../models/UpdateXrefsModel';
import { BaseApiService } from '../base-api.service';
import { UpdateResult } from '../../models/UpdateResults';
import { UserService } from '../user/user.service';
import { ISearchParameters } from '../../pages/page-components/Parameters/search-parameters/searchParameters';
import { SearchResults } from '../../models/SearchResults';
import { UploadUnspecFileResult } from '../../models/UploadUnspecFileResult';

@Injectable({
  providedIn: 'root',
})
export class SearchDataService {
  baseUrl = window.location.origin;
  token = '';
  canEdit: boolean = false;

  constructor(
    private baseAPIService: BaseApiService,
    user: UserService,
  ) {
    user.token.subscribe(value => {
      this.token = value;
    });
    user.canEdit.subscribe(v => {
      this.canEdit = v;
    });
  }

  //#region Search Functions
  getKnownSources(): Promise<DropDownModel[]> {
    let url = this.baseUrl + '/api/Search/Sources';
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.get<DropDownModel[]>(url);
  }

  searchForXrefs(parameters: ISearchParameters): Promise<SearchResults> {
    let url = this.baseUrl + '/api/Search/SearchXref';

    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.postTU<ISearchParameters, SearchResults>(
      url,
      parameters,
    );
  }
  //#endregion

  //#region Update Xref Validation
  updateXrefs(updates: UpdateXrefsModel): Promise<UpdateResult> {
    if (this.canEdit) {
      let url = this.baseUrl + '/api/Search/UpdateXrefs';
      this.baseAPIService.headerToken = this.token;
      return this.baseAPIService.postTU<UpdateXrefsModel, UpdateResult>(
        url,
        updates,
      );
    } else {
      let ur: UpdateResult = {
        success: false,
        recordsUpdated: 0,
        message: 'Not authorized to alter cross-references.',
      };
      return new Promise<UpdateResult>(res => {
        res(ur);
      });
    }
  }

  uploadDifferingUnspecUpdateFile(
    data: FormData,
  ): Promise<UploadUnspecFileResult> {
    if (this.canEdit) {
      let url = this.baseUrl + '/api/Search/DifferingUnspecUpdateFile';
      this.baseAPIService.headerToken = this.token;
      return this.baseAPIService.postFile<UploadUnspecFileResult>(url, data);
    } else {
      let ur: UploadUnspecFileResult = {
        success: false,
        message: 'Not authorized to alter cross-references.',
        changeToValid: 0,
        changeToInvalid: 0,
        reviewedChange: 0,
        unspecReviewedChange: 0,
        uiUpdateChange: 0,
      };

      return new Promise<UploadUnspecFileResult>(res => {
        res(ur);
      });
    }
  }
  //#endregion
}
